define('taoQtiItem/qtiXmlRenderer/renderers/choices/Gap',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'gap',
        template : tpl
    };
});
